import React, { useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import useForgetPassword from "../../mutation/forgetPassword/forgetPassword";

import Swal from "sweetalert2";

const schema = yup.object().shape({
  email: yup
    .string()
    .required("Required Field")
    .email("Please enter an email address"),
});

const ForgetPassword = (props) => {
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const [response, setData] = useForgetPassword();

  const onSubmit = (values) => {
    Swal.fire({
      title: "Loading..",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
      didOpen: async () => {
        setData({
          email: values.email,
        });
      },
    });
  };

  useEffect(() => {
    if (response.data) {
      props.history.push("/", { passwordReset: true });
      Swal.close();
    } else if (response.error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.errorMessage.message,
      });
    }
  }, [response]);

  const goBack = () => {
    window.location.href = "/";
  };

  return (
    <Grid container component="main" sx={{ minHeight: "100vh" }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={5}
        sx={{
          backgroundImage: "url(img/login.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(160deg, rgba(0,186,178,0.35) 0%, rgba(13,45,44,0.45) 100%)",
          },
        }}
      />
      <Grid
        item
        xs={12}
        sm={8}
        md={7}
        component={Paper}
        elevation={0}
        square
        sx={{
          display: "flex",
          alignItems: "center",
          bgcolor: "#fbfcfc",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 440,
            mx: "auto",
            px: { xs: 3, sm: 4 },
            py: { xs: 6, sm: 8 },
          }}
        >
          <IconButton
            onClick={goBack}
            aria-label="back"
            sx={{ color: "primary.main", p: 0, mb: 2 }}
          >
            <ArrowBackIcon fontSize="large" />
          </IconButton>

          <Box
            component="img"
            src="img/logo.png"
            alt="YSuites"
            sx={{ height: 48, mb: 2.5, display: "block" }}
          />

          <Typography
            component="h1"
            variant="h4"
            sx={{
              color: "primary.main",
              fontWeight: 800,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              mb: 0.5,
            }}
          >
            Middleware
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Reset your password to regain access.
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Typography component="h2" variant="h5" sx={{ mb: 1 }}>
            Forget Password
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please enter your email address below to reset your password.
          </Typography>

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              inputRef={register}
              error={errors.email != null}
              helperText={errors.email != null ? errors.email.message : null}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 3, mb: 2, py: 1.25 }}
            >
              Reset Password
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgetPassword;
